
export enum PageEnum {
  // basic login path
  BASE_LOGIN = '/login',
  // basic home path
  BASE_HOME = '/dashboard/index',
  // error page path
  ERROR_PAGE = '/exception',
}
export const PageWrapperFixedHeightKey = 'PageWrapperFixedHeight';
